<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OvOSdx/images/cover.jpg?1708648506530" alt="This image is the cover for the book Get Off Your Knees & Pray"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Get Off Your Knees & Pray
      </h1>
      <p class="bookDescription body article font2">
        <p>Having trouble talking to God?  You’re not alone.</p><p>We know we can talk to God, but it just sounds so important, so intimidating, so <i>religious</i>. We assume that only the very spiritual talk to him or hear from him directly. But author Sheila Walsh says, "Every sound we utter, every thank you we say, every tear we cry in God's presence is prayer."</p><p><i>Get Off Your Knees and Pray</i> is a real woman's guide to real prayer?from understanding the biblical basis for prayer to cultivating a vital personal relationship with God. It is the perfect blend of practical advice, personal stories, and biblical truth to encourage and help you achieve greater intimacy with God through prayer. Prayer is not just a few sentences we say while on our knees. It is living out our ongoing, every-moment commitment to God.</p><p>"Sheila steers us away from prayer as formula (say the right things the right way and God responds) and toward prayer as picture?a picture of God's desired relationship. Talking. Listening. Trusting. Living. This volume, warm and witty like its author, deserves a spot on every reading calendar." ?Max Lucado, best-selling author and minister</p><p>"No matter what kind of difficulty you have about prayer, this book will help. Sheila has experienced all of them, and she will take you through them to where God has taken her: straight into His very real and accepting Presence." ?Dr. Henry Cloud, speaker and coauthor of <i>Boundaries</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheila Walsh
      </h2>
      
      <p class="authorDescription body article"><P>Sheila Walsh is a powerful communicator, Bible teacher, and bestselling author with almost six million books sold. She is the author of the award-winning Gigi, God&rsquo;s Little Princess series, <I>It&rsquo;s Okay Not to Be Okay</I>, <I>Praying Women</I>, <I>Holding On When You Want to Let Go</I>, and more. She is cohost of the inspirational talk show <I>Life Today</I> with James and Betty Robison, which is seen worldwide by a potential audience of over 100 million viewers. Sheila lives in Dallas, Texas, with her husband, Barry, and son, Christian, who is in graduate school.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?573646ca